import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import Login from '@/components/Login'
import AdminRoutes from './admin'
import ResepcionestRoutes from './recepcionist'
import Privacidad from '@/components/Privacidad'
import MonitorAndAdminroutes from './monitorAndAdmin'

Vue.use(Router)
Vue.use(BootstrapVue)

const Routes = new Router({
    mode: 'history',
    routes: [
        {
            path: '/privacidad',
            name: 'privacidad',
            component: Privacidad
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        AdminRoutes,
        ResepcionestRoutes,
        MonitorAndAdminroutes
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

Routes.beforeEach((to, from, next) => {
    if (to.path !== '/login' && to.path !== '/recepcion' && to.path !== '/' && to.path !== '/habitaciones') {
        next()
        return
    }
    if (to.path === '/login') {
        next()
        return
    }

    if (to.path === '/recepcion') {
        next()
        return
    }

    if (to.path === '/') {
        next()
        return
    }

    if (to.path === '/habitaciones') {
        next()
        return
    }

    console.log(to.path)

    if (!store.getters.isLoggedIn) {
        next({path: '/login'})
    }

    if ((store.getters.isAdmin || store.getters.isMonitor) && store.getters.isLoggedIn) {
        next({path: '/habitaciones'})
    } else if (store.getters.isResepcionist && store.getters.isLoggedIn) {
        next({path: '/recepcion'})
    } else if ((store.getters.isCounter || store.getters.isSupport) && store.getters.isLoggedIn) {
        next({path: '/'})
    }

    next()
})

export default Routes



// WEBPACK FOOTER //
// ./src/router/index.js